import React from "react";
import { Link } from "react-router-dom";

/**
 * Reusable admin page header
 * - compact option for tighter pages like Daily Ops
 * - mobile friendly
 */
export default function AdminPageHeader({
  title,
  to = "/admin",
  backLabel = "← Return to Admin Portal",
  level = "h1",
  compact = false,
  style = {},
}) {
  const HeadingTag = level;

  return (
    <div
      className={`admin-page-header${compact ? " is-compact" : ""}`}
      style={style}
    >
      <HeadingTag className="admin-page-header-title">{title}</HeadingTag>

      <Link to={to} className="admin-page-header-back">
        {backLabel}
      </Link>
    </div>
  );
}